import { ClearBaseIcon } from '@tableau/icons/ClearBaseIcon';
import { ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { GuidedOnboardingBannerService } from '../services/GuidedOnboardingBannerService';
import { GuidedOnboardingStyles } from '../styles/GuidedOnboardingStyles';
import { GuidedOnboardingTestIds } from './GuidedOnboardingWelcomeBanner';

export function GuidedOnboardingBannerCloseButton(): JSX.Element {

    const handleClick = () => {
        GuidedOnboardingBannerService.instance.updateBannerVisibility(false, 'closeButton');
    };

    return (
        <ButtonWidget
            title={Messages.guidedOnboardingBannerCloseButton()}
            testId={GuidedOnboardingTestIds.closeButton}
            className={GuidedOnboardingStyles.closeButton}
            onClick={() => handleClick()}>
            <ClearBaseIcon size={14} />
        </ButtonWidget>
    );
}
